import React from 'react';
import {Footer} from "./StyledFooter";
import FB from "../../img/fb-icon.png";
import IG from "../../img/ig-icon.png";
const FooterComponent = () => (
    <Footer>
        <div>
            <p>Antiquoholics, 2020</p>
            <a href="https://www.facebook.com/Antiquoholics-746019502131675/">
                <img src={FB} alt='facebook' style={{marginRight: '6px'}}/>
            </a>
            <a href="https://www.instagram.com/antiquoholics/">
                <img src={IG} alt='instagram' style={{marginRight: '6px'}}/>
            </a>
            <p>Wood Green, N22 London</p>
        </div>
    </Footer>
);


export default FooterComponent;
